import { passkeyClient } from "@better-auth/passkey/client"
import { convexClient, crossDomainClient } from "@convex-dev/better-auth/client/plugins"
import {
  adminClient,
  genericOAuthClient,
  inferAdditionalFields,
  organizationClient,
} from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

import { auth } from "../../convex/betterAuth/auth"
import { getClientEnv } from "../env/client"
import { ac, owner, admin, manager, member } from "./access-control"

function createTowerAuthClient() {
  return createAuthClient({
    baseURL: getClientEnv().CONVEX_SITE_URL,
    plugins: [
      inferAdditionalFields<typeof auth>(),
      convexClient(),
      crossDomainClient(),
      genericOAuthClient(),
      adminClient(),
      passkeyClient(),
      organizationClient({
        ac,
        roles: { owner, admin, manager, member },
        dynamicAccessControl: { enabled: true },
        teams: {
          enabled: true,
        },
      }),
    ],
  })
}

type AuthClient = ReturnType<typeof createTowerAuthClient>

let authClientInstance: AuthClient | null = null

function getAuthClient(): AuthClient {
  if (!authClientInstance) {
    authClientInstance = createTowerAuthClient()
  }

  return authClientInstance
}

const authClient = new Proxy({} as AuthClient, {
  get(_target, property) {
    const client = getAuthClient()
    return Reflect.get(client, property, client)
  },
})

export { authClient }

export type AuthProviderId = "google" | "apple" | "google-lotlaw"

function isBuiltInSocialProvider(providerId: string): providerId is "google" | "apple" {
  return providerId === "google" || providerId === "apple"
}

export async function signInWithProvider(providerId: AuthProviderId, callbackURL: string) {
  const client = getAuthClient() as AuthClient & {
    signIn: AuthClient["signIn"] & {
      oauth2?: (args: { providerId: string; callbackURL: string }) => Promise<unknown>
    }
  }

  if (isBuiltInSocialProvider(providerId)) {
    return client.signIn.social({
      provider: providerId,
      callbackURL,
    })
  }

  if (!client.signIn.oauth2) {
    throw new Error(`OAuth provider ${providerId} is not configured on the client`)
  }

  return client.signIn.oauth2({
    providerId,
    callbackURL,
  })
}

// Create auth client type

// export type AuthClient = ReturnType<typeof createClient>

// Lazy initialization of auth client
// let _authClient: AuthClient | null = null

function _getAuthClient() {
  // if (!_authClient) {
  //   _authClient = createAuthClient({
  //     baseURL: getClientEnv().CONVEX_SITE_URL,
  //     plugins: [
  //       convexClient(),
  //       crossDomainClient(),
  //       organizationClient({
  //         teams: {
  //           enabled: true,
  //         },
  //       }),
  //     ],
  //   }) as AuthClient
  // }
  // return _authClient
}

// export const authClient = createAuthClient({
//   baseURL: getClientEnv().CONVEX_SITE_URL,
//   plugins: [
//     convexClient(),
//     crossDomainClient(),
//     organizationClient({
//       teams: {
//         enabled: true,
//       },
//     }),
//   ],
// })

// Export commonly used hooks with lazy initialization
export const useSession = () => {
  return getAuthClient().useSession()
}

export const useActiveOrganization = () => {
  return getAuthClient().useActiveOrganization()
}

export const signOut = () => {
  return getAuthClient().signOut()
}
